import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_LIMIT, DEFAULT_OFFSET } from '../constants';
import buildSortValues from './build-sort-values';
const getCorrectSort = (relations, filterProps, stringProps, useSortObject) => {
  const {
    sort,
    sortby,
    sortProperties = []
  } = filterProps;
  return buildSortValues([{
    sort,
    propsToDisplay: sortby
  }, ...sortProperties], relations, stringProps, useSortObject);
};
const getGenericRenderVariables = ({
  relations,
  filterProps = {},
  stringProps = [],
  rawQuery = {},
  useRandomSort = false
}) => {
  const rawQueryCopy = _objectSpread({}, rawQuery);
  const {
    limit = DEFAULT_LIMIT,
    offset
  } = filterProps;
  const limitToUse = Number(limit || DEFAULT_LIMIT);
  const offsetToUse = Number(offset || DEFAULT_OFFSET);
  if (useRandomSort) {
    const rawQueryStringified = JSON.stringify({
      query: {
        function_score: {
          query: rawQueryCopy && rawQueryCopy.query ? rawQueryCopy.query : rawQueryCopy,
          random_score: {},
          boost_mode: 'replace'
        }
      }
    });
    return {
      limit: limitToUse,
      offset: offsetToUse,
      rawQueryStringified
    };
  }
  const sort = getCorrectSort(relations, filterProps, stringProps, !!rawQueryCopy.sort);
  if (rawQueryCopy.sort && sort) {
    rawQueryCopy.sort = [...rawQueryCopy.sort, sort];
    return {
      limit: limitToUse,
      offset: offsetToUse,
      rawQueryStringified: JSON.stringify(rawQueryCopy)
    };
  }
  return _objectSpread(_objectSpread({
    limit: limitToUse,
    offset: offsetToUse
  }, sort), {}, {
    rawQueryStringified: JSON.stringify(rawQueryCopy)
  });
};
export default getGenericRenderVariables;
//# sourceMappingURL=get-generic-render-variables.js.map